var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _path, _path2, _line, _line2, _line3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletNocard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 102,
    viewBox: "0 0 178 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22.1631,
    width: 120.537,
    height: 70.313,
    rx: 8.03578,
    transform: "rotate(-10.5953 22.5 22.1631)",
    fill: "#DCDCDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3853_52085)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.9639,
    y: 19.542,
    width: 120.537,
    height: 70.313,
    rx: 8.03578,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0039,
    y: 56.2051,
    width: 23.354,
    height: 4.52012,
    rx: 2.26006,
    fill: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.8779,
    y: 56.2051,
    width: 23.354,
    height: 4.52012,
    rx: 2.26006,
    fill: "#EDEDED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.752,
    y: 56.2051,
    width: 23.354,
    height: 4.52012,
    rx: 2.26006,
    fill: "#EDEDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.626,
    y: 56.2051,
    width: 23.354,
    height: 4.52012,
    rx: 2.26006,
    fill: "#EDEDED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0039,
    y: 75.793,
    width: 55.7482,
    height: 3.01342,
    rx: 1.50671,
    fill: "#EDEDED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0039,
    y: 29.085,
    width: 24.1073,
    height: 18.0805,
    rx: 4.52012,
    fill: "#F1E5AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.433,
    cy: 36.1137,
    r: 6.02683,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.406,
    cy: 36.1137,
    r: 6.02683,
    fill: "#EFEEEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19.5,
    r: 3.5,
    fill: "#F82643"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 57,
    r: 2,
    fill: "#F82643"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.183 27.5156C172.44 26.7238 173.56 26.7238 173.817 27.5156C173.932 27.8697 174.262 28.1094 174.635 28.1094C175.467 28.1094 175.813 29.1748 175.14 29.6641C174.839 29.883 174.713 30.2709 174.828 30.625C175.085 31.4168 174.179 32.0752 173.505 31.5859C173.204 31.367 172.796 31.367 172.495 31.5859C171.821 32.0752 170.915 31.4168 171.172 30.625C171.287 30.2709 171.161 29.883 170.86 29.6641C170.187 29.1748 170.533 28.1094 171.365 28.1094C171.738 28.1094 172.068 27.8697 172.183 27.5156Z",
    fill: "#E4D383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4102 67.3541C13.7532 66.2984 15.2468 66.2984 15.5898 67.3541C15.7432 67.8262 16.1832 68.1459 16.6796 68.1459C17.7897 68.1459 18.2512 69.5664 17.3532 70.2188C16.9515 70.5106 16.7835 71.0279 16.9369 71.5C17.2799 72.5557 16.0716 73.4336 15.1735 72.7812C14.7719 72.4894 14.2281 72.4894 13.8265 72.7812C12.9284 73.4336 11.7201 72.5557 12.0631 71.5C12.2165 71.0279 12.0485 70.5106 11.6468 70.2188C10.7488 69.5664 11.2103 68.1459 12.3204 68.1459C12.8168 68.1459 13.2568 67.8262 13.4102 67.3541Z",
    fill: "#E4D383"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 156.854,
    y1: 16.6464,
    x2: 161.854,
    y2: 21.6464,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.795,
    y1: 52.0433,
    x2: 4.18299,
    y2: 59.0878,
    stroke: "#C9C6C6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.56101,
    y1: 55.4536,
    x2: 0.580052,
    y2: 56.5788,
    stroke: "#C9C6C6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3853_52085",
    x: 27.937,
    y: 19.542,
    width: 132.591,
    height: 82.3671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.02683
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.01342
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3853_52085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3853_52085",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletNocard);
export default __webpack_public_path__ + "static/media/wallet-nocard.aa44b29778d6dc307a21556bffb5635f.svg";
export { ForwardRef as ReactComponent };